(function () {
  const cartDrawerEl = document.querySelector('[data-js="cart-drawer"]');

  function shopifyLocaleApiPath(resourcePath) {
    const raw = (document.body && document.body.getAttribute("data-shopify-routes-root")) || "/";
    const t = String(raw).trim();
    if (t === "/" || t === "") return "/" + resourcePath.replace(/^\//, "");
    const base = t.replace(/\/$/, "");
    return base + "/" + resourcePath.replace(/^\//, "");
  }

  /**
   * One variant id + Shopify hidden fields; skips duplicate `id` keys.
   * `resolvedSubmitBtn` adds `name="add"` etc. (some stores / listeners expect it).
   */
  function cartAddFormDataFromProductForm(form, resolvedSubmitBtn) {
    const fd = new FormData();
    let hasQuantity = false;
    const idSelect = form.querySelector('select[name="id"]');
    let idVal = "";
    if (idSelect) {
      idVal = String(idSelect.value || "").trim();
    } else {
      const idInput = form.querySelector('input[name="id"]');
      idVal = idInput ? String(idInput.value || "").trim() : "";
    }
    form.querySelectorAll("input, select, textarea").forEach(function (el) {
      if (!el.name || el.disabled) return;
      if (el.name === "id") return;
      const typ = (el.type || "").toLowerCase();
      if (typ === "submit" || typ === "button") return;
      if (typ === "file") {
        if (el.files && el.files.length) fd.append(el.name, el.files[0]);
        return;
      }
      if ((typ === "checkbox" || typ === "radio") && !el.checked) return;
      if (el.name === "quantity") hasQuantity = true;
      fd.append(el.name, el.value);
    });
    if (idVal) fd.append("id", idVal);
    if (!hasQuantity) fd.append("quantity", "1");
    let subBtn = resolvedSubmitBtn;
    if (!(subBtn instanceof HTMLButtonElement) || !subBtn.name) {
      subBtn = form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
    }
    if (subBtn instanceof HTMLButtonElement && subBtn.name) {
      fd.append(subBtn.name, subBtn.value || "");
    }
    return fd;
  }

  /** URL-encoded when no file uploads — works better with Shopify’s fetch wrapper + /cart/add.js */
  function cartAddFetchInit(form, resolvedSubmitBtn) {
    const fd = cartAddFormDataFromProductForm(form, resolvedSubmitBtn);
    const hasFile = Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (el) {
      return el.files && el.files.length;
    });
    if (hasFile) {
      return {
        body: fd,
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      };
    }
    const sp = new URLSearchParams();
    fd.forEach(function (val, key) {
      sp.append(key, val);
    });
    return {
      body: sp.toString(),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest",
      },
    };
  }

  /** For 422 retry: same line as form POST, without file uploads. */
  function cartAddJsonItemsFromForm(form) {
    const hasFile = Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (el) {
      return el.files && el.files.length;
    });
    if (hasFile) return null;

    const idSelect = form.querySelector('select[name="id"]');
    let idRaw = "";
    if (idSelect) idRaw = String(idSelect.value || "").trim();
    else {
      const idInput = form.querySelector('input[name="id"]');
      idRaw = idInput ? String(idInput.value || "").trim() : "";
    }
    const vid = parseInt(idRaw, 10);
    if (!vid) return null;

    const qEl = form.querySelector('[name="quantity"]');
    const q = Math.max(1, parseInt(String(qEl && qEl.value ? qEl.value : "1"), 10) || 1);

    const item = { id: vid, quantity: q };

    const props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if (!el.name || el.disabled) return;
      const m = el.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      const typ = (el.type || "").toLowerCase();
      if (typ === "checkbox" || typ === "radio") {
        if (el.checked) props[m[1]] = el.value || "";
      } else if (String(el.value || "").trim() !== "") {
        props[m[1]] = el.value;
      }
    });
    if (Object.keys(props).length) item.properties = props;

    const spEl = form.querySelector('[name="selling_plan"]');
    if (spEl && String(spEl.value || "").trim() !== "") {
      const spid = parseInt(String(spEl.value).trim(), 10);
      if (spid) item.selling_plan = spid;
    }

    return { items: [item] };
  }

  function parseCartAddResponse(res, errFallback) {
    if (!res.ok) {
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) {
        return res.json().then(function (data) {
          throw data;
        });
      }
      return res.text().then(function (text) {
        throw {
          description: (text && text.replace(/<[^>]+>/g, "").trim().slice(0, 280)) || errFallback,
        };
      });
    }
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
      return res.json().catch(function () {
        return {};
      });
    }
    return res.text().then(function () {
      return {};
    });
  }

  /** Plain sentence for cart drawer — never raw JSON blobs. */
  function humanCartAddError(err, fallback) {
    const fb = (fallback && String(fallback).trim()) || "";
    if (err instanceof Error) {
      const em = String(err.message || "").trim();
      if (em === "cart") return fb;
      return em ? em.slice(0, 480) : fb;
    }
    function fromObject(o, depth) {
      if (!o || typeof o !== "object" || depth > 4) return "";
      const tryStr = function (s) {
        if (typeof s !== "string") return "";
        const t = s.trim();
        if (!t) return "";
        if (t.charAt(0) === "{" && t.charAt(t.length - 1) === "}") {
          try {
            const inner = JSON.parse(t);
            const nested = fromObject(inner, depth + 1);
            if (nested) return nested;
          } catch (e) {
            /* keep t */
          }
        }
        return t.slice(0, 480);
      };
      let out = tryStr(o.description) || tryStr(o.message);
      if (out) return out;
      const m = o.message;
      if (Array.isArray(m) && m[0]) return String(m[0]).slice(0, 480);
      const errs = o.errors;
      if (errs && typeof errs === "object") {
        const keys = Object.keys(errs);
        for (let i = 0; i < keys.length; i++) {
          const v = errs[keys[i]];
          if (Array.isArray(v) && v[0]) return String(v[0]).slice(0, 480);
          if (typeof v === "string" && v.trim()) return v.trim().slice(0, 480);
        }
      }
      return "";
    }
    if (typeof err === "string") {
      const t = err.trim();
      if (t.charAt(0) === "{" && t.charAt(t.length - 1) === "}") {
        try {
          const p = JSON.parse(t);
          const out = fromObject(p, 0);
          if (out) return out;
        } catch (e) {
          /* fall through */
        }
      }
      return t.slice(0, 480);
    }
    if (err && typeof err === "object") {
      const out = fromObject(err, 0);
      if (out) return out;
    }
    return fb;
  }

  // --- Announcement bar carousel ---
  const slides = document.querySelectorAll('[data-js="announcement-slides"] .announcement-bar__slide');
  const prevBtn = document.querySelector('[data-js="announcement-prev"]');
  const nextBtn = document.querySelector('[data-js="announcement-next"]');

  if (slides.length > 1) {
    let current = 0;
    let autoTimer;

    function showSlide(index) {
      slides[current].classList.remove("is-active");
      current = (index + slides.length) % slides.length;
      slides[current].classList.add("is-active");
    }

    function startAuto() {
      autoTimer = setInterval(function () {
        showSlide(current + 1);
      }, 4000);
    }

    function resetAuto() {
      clearInterval(autoTimer);
      startAuto();
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        showSlide(current - 1);
        resetAuto();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        showSlide(current + 1);
        resetAuto();
      });
    }

    startAuto();
  }

  // --- Mobile nav drawer ---
  const toggle = document.querySelector('[data-js="nav-toggle"]');
  const drawer = document.querySelector('[data-js="nav-drawer"]');
  const overlay = document.querySelector('[data-js="nav-overlay"]');
  const closeBtn = document.querySelector('[data-js="nav-close"]');

  function openDrawer() {
    if (!drawer || !toggle) return;
    drawer.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!drawer || !toggle) return;
    drawer.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  if (toggle && drawer) {
    toggle.addEventListener("click", function () {
      const isOpen = drawer.classList.contains("is-open");
      if (isOpen) closeDrawer();
      else openDrawer();
    });
  }

  if (overlay) overlay.addEventListener("click", closeDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

  // --- Collection PLP filter drawer (re-query nodes for AJAX section swaps) ---
  function closePlpFilters() {
    const plpSidebarEl = document.querySelector('[data-js="plp-sidebar"]');
    const plpBackdropEl = document.querySelector('[data-js="plp-filter-backdrop"]');
    const plpToggleEl = document.querySelector('[data-js="plp-filter-toggle"]');
    if (!plpSidebarEl) return;
    plpSidebarEl.classList.remove("is-open");
    if (plpBackdropEl) plpBackdropEl.classList.remove("is-visible");
    document.body.classList.remove("plp-filters-open");
    if (plpToggleEl) plpToggleEl.setAttribute("aria-expanded", "false");
  }

  function openPlpFilters() {
    const plpSidebarEl = document.querySelector('[data-js="plp-sidebar"]');
    const plpBackdropEl = document.querySelector('[data-js="plp-filter-backdrop"]');
    const plpToggleEl = document.querySelector('[data-js="plp-filter-toggle"]');
    if (!plpSidebarEl) return;
    plpSidebarEl.classList.add("is-open");
    if (plpBackdropEl) plpBackdropEl.classList.add("is-visible");
    document.body.classList.add("plp-filters-open");
    if (plpToggleEl) plpToggleEl.setAttribute("aria-expanded", "true");
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest('[data-js="plp-filter-backdrop"]')) {
      closePlpFilters();
      return;
    }
    if (e.target.closest('[data-js="plp-filter-close"]')) {
      closePlpFilters();
      return;
    }
    const tgl = e.target.closest('[data-js="plp-filter-toggle"]');
    if (tgl) {
      e.preventDefault();
      const sb = document.querySelector('[data-js="plp-sidebar"]');
      if (sb) {
        if (sb.classList.contains("is-open")) closePlpFilters();
        else openPlpFilters();
      }
      return;
    }
  });

  function plpAjaxRoot() {
    return document.querySelector('[data-js="plp-ajax-root"]');
  }

  function syncPlpPriceSliders(facet) {
    if (!facet) return;
    const rMin = facet.querySelector("[data-plp-range-min]");
    const rMax = facet.querySelector("[data-plp-range-max]");
    const hMin = facet.querySelector("[data-plp-price-min-hidden]");
    const hMax = facet.querySelector("[data-plp-price-max-hidden]");
    const readMin = facet.querySelector("[data-plp-readout-min]");
    const readMax = facet.querySelector("[data-plp-readout-max]");
    if (!rMin || !rMax || !hMin || !hMax) return;
    let a = parseInt(rMin.value, 10);
    let b = parseInt(rMax.value, 10);
    if (a > b) {
      if (document.activeElement === rMin) {
        rMax.value = String(a);
        b = a;
      } else {
        rMin.value = String(b);
        a = b;
      }
    }
    hMin.value = String(a);
    hMax.value = String(b);
    const root = plpAjaxRoot();
    const sym = root && root.dataset.plpCurrency ? root.dataset.plpCurrency : "";
    const fmt = function (cents) {
      return sym + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    if (readMin) readMin.textContent = fmt(a);
    if (readMax) readMax.textContent = fmt(b);
    const track = facet.querySelector(".plp__price-slider-track");
    if (track && rMin.max) {
      const max = parseInt(rMin.max, 10) || 1;
      const p1 = (a / max) * 100;
      const p2 = (b / max) * 100;
      track.style.background =
        "linear-gradient(to right, rgba(74,55,50,0.12) " +
        p1 +
        "%, var(--color-text, #4a3732) " +
        p1 +
        "% " +
        p2 +
        "%, rgba(74,55,50,0.12) " +
        p2 +
        "%)";
    }
  }

  function initPlpPriceSlidersIn(rootEl) {
    (rootEl || document).querySelectorAll("[data-plp-price-facet]").forEach(function (facet) {
      syncPlpPriceSliders(facet);
    });
  }

  function plpBuildFacetParams(form, root) {
    const params = new URLSearchParams();
    const fd = new FormData(form);
    for (const pair of fd.entries()) {
      if (pair[1] === "") continue;
      params.append(pair[0], pair[1]);
    }
    const priceFacet = form.querySelector("[data-plp-price-facet]");
    if (priceFacet) {
      const cap = parseInt(priceFacet.dataset.plpRangeMax, 10) || 0;
      const hMin = priceFacet.querySelector("[data-plp-price-min-hidden]");
      const hMax = priceFacet.querySelector("[data-plp-price-max-hidden]");
      if (hMin && hMax && hMin.name && hMax.name) {
        const minV = parseInt(hMin.value, 10) || 0;
        const maxV = parseInt(hMax.value, 10) || cap;
        if (minV <= 0 && maxV >= cap) {
          params.delete(hMin.name);
          params.delete(hMax.name);
        }
      }
    }
    const sortNow = document.querySelector('[data-js="plp-sort-select"]');
    if (sortNow && sortNow.value) params.set("sort_by", sortNow.value);
    params.set("sections", (root && root.dataset.plpSectionKey) || "main");
    return params;
  }

  async function plpFetchAndReplace(requestUrl) {
    const root = plpAjaxRoot();
    if (!root) return;
    const sectionKey = root.dataset.plpSectionKey || "main";
    root.classList.add("plp--loading");
    try {
      const res = await fetch(requestUrl, { credentials: "same-origin" });
      const ct = res.headers.get("content-type") || "";
      if (!res.ok || !ct.includes("application/json")) throw new Error("bad response");
      const json = await res.json();
      const parsed = typeof json === "object" && json !== null ? json : {};
      const html = parsed[sectionKey];
      if (!html || typeof html !== "string") throw new Error("no section");
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector('[data-js="plp-ajax-root"]');
      if (!fresh) throw new Error("no root");
      root.replaceWith(fresh);
      const displayUrl = new URL(requestUrl, window.location.origin);
      displayUrl.searchParams.delete("sections");
      history.pushState({}, "", displayUrl.pathname + displayUrl.search);
      initPlpPriceSlidersIn(document);
    } catch (e) {
      root.classList.remove("plp--loading");
      const fallback = new URL(requestUrl, window.location.origin);
      fallback.searchParams.delete("sections");
      window.location.href = fallback.toString();
    }
  }

  let plpFacetDebounce;
  function plpApplyFacetAjax() {
    const root = plpAjaxRoot();
    const form = document.getElementById("collection-facet-form");
    if (!root || !form) return;
    const base = root.dataset.plpCollectionUrl || window.location.pathname;
    const params = plpBuildFacetParams(form, root);
    const url = new URL(base, window.location.origin);
    params.forEach(function (v, k) {
      url.searchParams.append(k, v);
    });
    plpFetchAndReplace(url.toString());
  }

  function plpScheduleFacetAjax() {
    clearTimeout(plpFacetDebounce);
    plpFacetDebounce = setTimeout(plpApplyFacetAjax, 340);
  }

  async function plpApplySortAjax() {
    const root = plpAjaxRoot();
    const sortForm = document.querySelector('[data-js="plp-sort-form"]');
    if (!root || !sortForm) return;
    const params = new URLSearchParams(new FormData(sortForm));
    params.set("sections", root.dataset.plpSectionKey || "main");
    const url = new URL(sortForm.action || window.location.pathname, window.location.origin);
    params.forEach(function (v, k) {
      url.searchParams.append(k, v);
    });
    plpFetchAndReplace(url.toString());
  }

  document.addEventListener("change", function (e) {
    if (!e.target.matches('[data-js="plp-sort-select"]')) return;
    const sortForm = document.querySelector('[data-js="plp-sort-form"]');
    if (plpAjaxRoot() && sortForm) plpApplySortAjax();
    else if (sortForm) sortForm.submit();
  });

  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (form instanceof HTMLFormElement && cartDrawerEl) {
      const act = (form.getAttribute("action") || "").toLowerCase();
      if (act.includes("/cart/add")) {
        const addUrl = new URL(form.action, window.location.href);
        const pathNorm = addUrl.pathname.replace(/\/$/, "") || "/";
        if (!/\/cart\/add$/i.test(pathNorm)) {
          return;
        }
        e.preventDefault();
        if (form.dataset.atcPending === "1") {
          return;
        }
        form.dataset.atcPending = "1";
        addUrl.pathname = pathNorm + ".js";

        const addToCartBtn =
          e.submitter instanceof HTMLButtonElement && e.submitter.type === "submit"
            ? e.submitter
            : form.querySelector('button[type="submit"][name="add"]') ||
              form.querySelector('button[type="submit"]');
        if (addToCartBtn) {
          addToCartBtn.setAttribute("aria-busy", "true");
          addToCartBtn.classList.add("is-atc-loading");
        }

        const errFallback = (cartDrawerEl && cartDrawerEl.dataset && cartDrawerEl.dataset.errorGeneric) || "";
        const fetchInit = cartAddFetchInit(form, addToCartBtn);
        const addUrlStr = addUrl.toString();

        fetch(addUrlStr, {
          method: "POST",
          body: fetchInit.body,
          headers: fetchInit.headers,
          credentials: "same-origin",
        })
          .then(function (res) {
            if (res.status === 422) {
              const jsonPayload = cartAddJsonItemsFromForm(form);
              if (jsonPayload) {
                return fetch(addUrlStr, {
                  method: "POST",
                  credentials: "same-origin",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                  body: JSON.stringify(jsonPayload),
                });
              }
            }
            return res;
          })
          .then(function (res) {
            return parseCartAddResponse(res, errFallback);
          })
          .then(function () {
            cartDrawerHideError();
            return fetch(shopifyLocaleApiPath("cart.js"), {
              credentials: "same-origin",
              headers: { Accept: "application/json" },
            }).then(function (r) {
              if (!r.ok) throw new Error("cart");
              return r.json();
            });
          })
          .then(function (cart) {
            cartDrawerRender(cart);
            if (addToCartBtn) {
              addToCartBtn.classList.remove("is-atc-loading");
              addToCartBtn.removeAttribute("aria-busy");
              addToCartBtn.classList.add("is-atc-success");
              window.setTimeout(function () {
                addToCartBtn.classList.remove("is-atc-success");
              }, 550);
            }
            openCartDrawer();
          })
          .catch(function (err) {
            const msg =
              humanCartAddError(err, errFallback) ||
              errFallback ||
              "Could not add to cart.";
            cartDrawerShowError(msg);
            openCartDrawer();
          })
          .finally(function () {
            delete form.dataset.atcPending;
            if (addToCartBtn) {
              addToCartBtn.classList.remove("is-atc-loading");
              addToCartBtn.removeAttribute("aria-busy");
            }
          });
        return;
      }
    }

    if (e.target.id === "collection-facet-form") {
      if (plpAjaxRoot()) {
        e.preventDefault();
        plpApplyFacetAjax();
      }
    } else if (e.target.getAttribute("data-js") === "plp-sort-form") {
      if (plpAjaxRoot()) {
        e.preventDefault();
        plpApplySortAjax();
      }
    }
  });

  document.addEventListener("change", function (e) {
    if (!plpAjaxRoot()) return;
    const form = e.target.closest("#collection-facet-form");
    if (!form) return;
    if (e.target.classList.contains("plp__price-range")) return;
    plpScheduleFacetAjax();
  });

  document.addEventListener("input", function (e) {
    if (!plpAjaxRoot()) return;
    if (!e.target.classList.contains("plp__price-range")) return;
    const facet = e.target.closest("[data-plp-price-facet]");
    if (!facet || !document.getElementById("collection-facet-form")?.contains(facet)) return;
    syncPlpPriceSliders(facet);
    plpScheduleFacetAjax();
  });

  document.addEventListener("click", function (e) {
    const root = plpAjaxRoot();
    if (!root) return;
    const pill = e.target.closest(".plp__facet-pill, .plp__facet-clear");
    if (pill && root.contains(pill)) {
      e.preventDefault();
      const u = new URL(pill.getAttribute("href"), window.location.origin);
      u.searchParams.set("sections", root.dataset.plpSectionKey || "main");
      const sortEl = document.querySelector('[data-js="plp-sort-select"]');
      if (sortEl && sortEl.value) u.searchParams.set("sort_by", sortEl.value);
      plpFetchAndReplace(u.toString());
      return;
    }
    const pag = e.target.closest(".plp__pagination a");
    if (pag && root.contains(pag)) {
      e.preventDefault();
      const u = new URL(pag.getAttribute("href"), window.location.origin);
      u.searchParams.set("sections", root.dataset.plpSectionKey || "main");
      plpFetchAndReplace(u.toString());
    }
  });

  initPlpPriceSlidersIn(document);

  // --- Cart drawer (AJAX add-to-cart) ---
  let cartDrawerPrevFocus = null;

  function cartDrawerFormatMoney(cents) {
    const tpl = cartDrawerEl && cartDrawerEl.dataset.moneyFormat;
    const amount = (cents / 100).toFixed(2);
    if (!tpl) return amount;
    return tpl
      .replace(/\{\{\s*amount\s*\}\}/gi, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(cents / 100)));
  }

  function cartDrawerUpdateBadge(count) {
    const badge = document.querySelector(".site-header__cart-count");
    if (badge) badge.textContent = String(count);
  }

  function closeCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerEl.classList.remove("is-open");
    cartDrawerEl.setAttribute("aria-hidden", "true");
    const navOpen = document.querySelector('[data-js="nav-drawer"]')?.classList.contains("is-open");
    const plpOpen = document.querySelector('[data-js="plp-sidebar"]')?.classList.contains("is-open");
    if (!navOpen && !plpOpen) document.body.style.overflow = "";
    if (cartDrawerPrevFocus && typeof cartDrawerPrevFocus.focus === "function") {
      cartDrawerPrevFocus.focus();
      cartDrawerPrevFocus = null;
    }
  }

  function openCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerPrevFocus = document.activeElement;
    cartDrawerEl.classList.add("is-open");
    cartDrawerEl.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    const panel = cartDrawerEl.querySelector(".cart-drawer__panel");
    if (panel && typeof panel.focus === "function") panel.focus();
  }

  function cartDrawerHideError() {
    const err = cartDrawerEl && cartDrawerEl.querySelector('[data-js="cart-drawer-error"]');
    if (err) {
      err.hidden = true;
      err.textContent = "";
    }
  }

  function cartDrawerShowError(msg) {
    const err = cartDrawerEl && cartDrawerEl.querySelector('[data-js="cart-drawer-error"]');
    if (!err) return;
    err.textContent = msg || "";
    err.hidden = !msg;
  }

  function cartDrawerRender(cart) {
    if (!cartDrawerEl) return;
    const linesEl = cartDrawerEl.querySelector('[data-js="cart-drawer-lines"]');
    const emptyEl = cartDrawerEl.querySelector('[data-js="cart-drawer-empty"]');
    const foot = cartDrawerEl.querySelector('[data-js="cart-drawer-foot"]');
    const subEl = cartDrawerEl.querySelector('[data-js="cart-drawer-subtotal"]');
    const removeLabel = (cartDrawerEl.dataset.removeLabel || "Remove").trim();
    if (!linesEl || !emptyEl || !foot || !subEl) return;

    const count = cart.item_count || 0;
    cartDrawerUpdateBadge(count);

    if (!cart.items || cart.items.length === 0) {
      linesEl.innerHTML = "";
      linesEl.hidden = true;
      emptyEl.hidden = false;
      foot.hidden = true;
      subEl.textContent = "";
      return;
    }

    emptyEl.hidden = true;
    linesEl.hidden = false;
    foot.hidden = false;
    subEl.textContent = cartDrawerFormatMoney(cart.total_price);

    linesEl.innerHTML = "";
    cart.items.forEach(function (item, index) {
      const li = document.createElement("li");
      li.className = "cart-drawer__line";
      const inner = document.createElement("div");
      inner.className = "cart-drawer__line-inner";
      if (item.image) {
        const img = document.createElement("img");
        img.className = "cart-drawer__thumb";
        img.src = item.image;
        img.alt = "";
        img.width = 72;
        img.height = 72;
        img.loading = "lazy";
        inner.appendChild(img);
      } else {
        const ph = document.createElement("span");
        ph.className = "cart-drawer__thumb cart-drawer__thumb--placeholder";
        ph.setAttribute("aria-hidden", "true");
        inner.appendChild(ph);
      }
      const body = document.createElement("div");
      body.className = "cart-drawer__line-body";
      const titleA = document.createElement("a");
      titleA.className = "cart-drawer__line-title";
      titleA.href = item.url || "#";
      titleA.textContent = item.product_title || "";
      body.appendChild(titleA);
      if (item.variant_title && item.variant_title !== "Default Title") {
        const vp = document.createElement("p");
        vp.className = "cart-drawer__variant";
        vp.textContent = item.variant_title;
        body.appendChild(vp);
      }
      const meta = document.createElement("p");
      meta.className = "cart-drawer__line-meta";
      meta.textContent =
        "Qty " + (item.quantity || 0) + " · " + cartDrawerFormatMoney(item.final_line_price);
      body.appendChild(meta);
      const rm = document.createElement("button");
      rm.type = "button";
      rm.className = "cart-drawer__remove";
      rm.setAttribute("data-cart-line", String(index + 1));
      rm.textContent = removeLabel;
      body.appendChild(rm);
      inner.appendChild(body);
      li.appendChild(inner);
      linesEl.appendChild(li);
    });
  }

  if (cartDrawerEl) {
    const cartUrl = document.body.getAttribute("data-cart-url");
    const checkoutUrl = document.body.getAttribute("data-checkout-url");
    if (cartUrl) {
      const v = cartDrawerEl.querySelector('[data-js="cart-drawer-view-link"]');
      if (v) v.setAttribute("href", cartUrl);
    }
    if (checkoutUrl) {
      const c = cartDrawerEl.querySelector('[data-js="cart-drawer-checkout-link"]');
      if (c) c.setAttribute("href", checkoutUrl);
    }

    cartDrawerEl.addEventListener("click", function (e) {
      const closer = e.target.closest('[data-js="cart-drawer-close"]');
      if (closer && cartDrawerEl.contains(closer)) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }
      const rm = e.target.closest(".cart-drawer__remove[data-cart-line]");
      if (!rm || !cartDrawerEl.contains(rm)) return;
      const line = parseInt(rm.getAttribute("data-cart-line"), 10);
      if (isNaN(line)) return;
      rm.disabled = true;
      fetch(shopifyLocaleApiPath("cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: 0 }),
        credentials: "same-origin",
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (nextCart) {
          cartDrawerRender(nextCart);
        })
        .catch(function () {
          rm.disabled = false;
        });
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const lbEsc = document.querySelector('[data-js="pdp-lightbox"].is-open');
    if (lbEsc) {
      const closeBtn = lbEsc.querySelector('[data-js="pdp-lightbox-close-btn"]');
      if (closeBtn) closeBtn.click();
      return;
    }
    if (cartDrawerEl && cartDrawerEl.classList.contains("is-open")) {
      closeCartDrawer();
      return;
    }
    if (drawer && drawer.classList.contains("is-open")) closeDrawer();
    const plpSb = document.querySelector('[data-js="plp-sidebar"]');
    if (plpSb && plpSb.classList.contains("is-open")) closePlpFilters();
  });

  // --- Search redirect ---
  const searchToggle = document.querySelector('[data-js="search-toggle"]');
  if (searchToggle) {
    searchToggle.addEventListener("click", function () {
      const url = document.body.getAttribute("data-search-url") || "/search";
      window.location.href = url;
    });
  }

  // --- PDP gallery + lightbox (matches product.html / main.js) ---
  const gRoot = document.querySelector('[data-js="pdp-gallery-root"]');
  const gTrack = document.querySelector('[data-js="pdp-gallery-track"]');
  const gSlides = document.querySelectorAll("[data-pdp-gallery-slide]");
  const gPrev = document.querySelector('[data-js="pdp-gallery-prev"]');
  const gNext = document.querySelector('[data-js="pdp-gallery-next"]');
  const gThumbsWrap = document.querySelector('[data-js="pdp-gallery-thumbs"]');
  const gZoomBtn = document.querySelector('[data-js="pdp-gallery-zoom"]');

  if (gRoot && gTrack && gSlides.length >= 1) {
    let gCurrent = 0;
    const gCount = gSlides.length;
    const gImgs = Array.prototype.slice.call(gRoot.querySelectorAll("img.pdp-gallery__img"));

    const lb = document.querySelector('[data-js="pdp-lightbox"]');
    const lbImg = document.querySelector('[data-js="pdp-lightbox-img"]');
    const lbPrev = document.querySelector('[data-js="pdp-lightbox-prev"]');
    const lbNext = document.querySelector('[data-js="pdp-lightbox-next"]');
    const lbCs = document.querySelectorAll('[data-js="pdp-lightbox-close"], [data-js="pdp-lightbox-close-btn"]');
    let lbOpen = false;
    let lbTouchStartX = 0;

    function gUpdateButtons() {
      if (gPrev) gPrev.disabled = gCurrent <= 0;
      if (gNext) gNext.disabled = gCurrent >= gCount - 1;
    }

    function gUpdateThumbs() {
      if (!gThumbsWrap) return;
      gThumbsWrap.querySelectorAll(".pdp-gallery__thumb").forEach(function (t, i) {
        if (i === gCurrent) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
    }

    function gGoTo(index) {
      gCurrent = Math.max(0, Math.min(gCount - 1, index));
      gTrack.style.transform = "translateX(-" + gCurrent * 100 + "%)";
      gSlides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === gCurrent);
      });
      const activeImg = gImgs[gCurrent];
      if (activeImg && activeImg.src) {
        const activeSrc = activeImg.currentSrc || activeImg.src;
        gRoot.style.setProperty("--pdp-active-image", 'url("' + activeSrc.replace(/"/g, '\\"') + '")');
      }
      gUpdateButtons();
      gUpdateThumbs();
      if (lbOpen) lbSync();
    }

    function lbSync() {
      if (!lb || !lbImg) return;
      const img = gImgs[gCurrent];
      if (!img || !img.src) return;
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt || "";
      if (lbPrev) lbPrev.disabled = gCurrent <= 0;
      if (lbNext) lbNext.disabled = gCurrent >= gCount - 1;
    }

    function lbOpenAt(index) {
      if (!lb || !lbImg) return;
      lbOpen = true;
      gGoTo(index);
      lb.classList.add("is-open");
      lb.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      lbSync();
    }

    function lbClose() {
      if (!lb) return;
      lbOpen = false;
      lb.classList.remove("is-open");
      lb.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      if (lbImg) lbImg.removeAttribute("src");
    }

    if (gPrev) gPrev.addEventListener("click", () => gGoTo(gCurrent - 1));
    if (gNext) gNext.addEventListener("click", () => gGoTo(gCurrent + 1));

    if (gThumbsWrap) {
      gThumbsWrap.innerHTML = "";
      gSlides.forEach(function (slide, idx) {
        const img = slide.querySelector("img");
        if (!img || !img.src) return;
        const b = document.createElement("button");
        b.type = "button";
        b.className = "pdp-gallery__thumb";
        b.setAttribute("data-gallery-thumb", String(idx));
        b.setAttribute("aria-label", "Show image " + (idx + 1) + " of " + gCount);
        const ti = document.createElement("img");
        ti.src = img.currentSrc || img.src;
        ti.alt = "";
        ti.loading = "lazy";
        b.appendChild(ti);
        gThumbsWrap.appendChild(b);
      });
      gThumbsWrap.addEventListener("click", function (e) {
        const t = e.target.closest(".pdp-gallery__thumb");
        if (!t) return;
        const idx = parseInt(t.getAttribute("data-gallery-thumb"), 10);
        if (!isNaN(idx)) gGoTo(idx);
      });
    }

    let gTouchStartX = 0;
    gTrack.addEventListener(
      "touchstart",
      function (e) {
        gTouchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    gTrack.addEventListener(
      "touchend",
      function (e) {
        const x = e.changedTouches[0].screenX;
        const diff = gTouchStartX - x;
        if (Math.abs(diff) > 50) {
          if (diff > 0) gGoTo(gCurrent + 1);
          else gGoTo(gCurrent - 1);
        }
      },
      { passive: true }
    );

    if (gZoomBtn) gZoomBtn.addEventListener("click", () => lbOpenAt(gCurrent));
    if (lbPrev) lbPrev.addEventListener("click", () => gGoTo(gCurrent - 1));
    if (lbNext) lbNext.addEventListener("click", () => gGoTo(gCurrent + 1));
    lbCs.forEach(function (el) {
      el.addEventListener("click", lbClose);
    });

    document.addEventListener("keydown", function (e) {
      if (!lbOpen) return;
      if (e.key === "ArrowLeft") gGoTo(gCurrent - 1);
      if (e.key === "ArrowRight") gGoTo(gCurrent + 1);
    });

    if (lb) {
      lb.addEventListener(
        "touchstart",
        function (e) {
          lbTouchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      lb.addEventListener(
        "touchend",
        function (e) {
          if (!lbOpen) return;
          const x = e.changedTouches[0].screenX;
          const diff = lbTouchStartX - x;
          if (Math.abs(diff) > 50) {
            if (diff > 0) gGoTo(gCurrent + 1);
            else gGoTo(gCurrent - 1);
          }
        },
        { passive: true }
      );
    }

    gGoTo(0);
  }

  // --- Hero slider ---
  const heroTrack = document.querySelector('[data-js="hero-track"]');
  const heroSlides = document.querySelectorAll("[data-hero-slide]");
  const heroPrev = document.querySelector('[data-js="hero-prev"]');
  const heroNext = document.querySelector('[data-js="hero-next"]');
  const heroDots = document.querySelectorAll('[data-js="hero-dots"] .hero__dot');

  if (heroTrack && heroSlides.length > 0) {
    let heroCurrent = 0;
    let heroAutoTimer;
    const heroCount = heroSlides.length;
    const heroEl = heroTrack.closest(".hero");
    const heroAutoplayEnabled = heroEl ? heroEl.getAttribute("data-hero-autoplay") !== "false" : true;
    const heroAutoplaySecondsRaw = heroEl ? parseInt(heroEl.getAttribute("data-hero-autoplay-seconds"), 10) : NaN;
    const heroAutoplayMs = !isNaN(heroAutoplaySecondsRaw) && heroAutoplaySecondsRaw > 0 ? heroAutoplaySecondsRaw * 1000 : 5000;

    function syncHeroVideos() {
      heroSlides.forEach(function (slide, i) {
        const v = slide.querySelector("video");
        if (!v) return;
        if (i === heroCurrent) {
          v.play().catch(function () {});
        } else {
          v.pause();
          try {
            v.currentTime = 0;
          } catch (e) {}
        }
      });
    }

    function goToHeroSlide(index) {
      if (heroCount <= 0) return;
      if (index >= heroCount) {
        heroTrack.style.transition = "none";
        heroCurrent = 0;
        heroTrack.style.transform = "translateX(0)";
        // Prevent full-track reverse animation when wrapping last -> first.
        requestAnimationFrame(function () {
          heroTrack.style.transition = "";
          heroDots.forEach((dot, i) => dot.classList.toggle("is-active", i === heroCurrent));
          heroSlides.forEach((slide, i) => slide.classList.toggle("is-active", i === heroCurrent));
          syncHeroVideos();
        });
        return;
      }
      if (index < 0) {
        heroTrack.style.transition = "none";
        heroCurrent = heroCount - 1;
        heroTrack.style.transform = "translateX(-" + heroCurrent * 100 + "%)";
        requestAnimationFrame(function () {
          heroTrack.style.transition = "";
          heroDots.forEach((dot, i) => dot.classList.toggle("is-active", i === heroCurrent));
          heroSlides.forEach((slide, i) => slide.classList.toggle("is-active", i === heroCurrent));
          syncHeroVideos();
        });
        return;
      }
      heroCurrent = index;
      heroTrack.style.transform = "translateX(-" + heroCurrent * 100 + "%)";
      heroDots.forEach((dot, i) => dot.classList.toggle("is-active", i === heroCurrent));
      heroSlides.forEach((slide, i) => slide.classList.toggle("is-active", i === heroCurrent));
      syncHeroVideos();
    }

    function startHeroAuto() {
      if (heroCount <= 1 || !heroAutoplayEnabled) return;
      heroAutoTimer = setInterval(() => goToHeroSlide(heroCurrent + 1), heroAutoplayMs);
    }

    function resetHeroAuto() {
      clearInterval(heroAutoTimer);
      startHeroAuto();
    }

    if (heroCount > 1) {
      if (heroPrev) {
        heroPrev.addEventListener("click", function () {
          goToHeroSlide(heroCurrent - 1);
          resetHeroAuto();
        });
      }

      if (heroNext) {
        heroNext.addEventListener("click", function () {
          goToHeroSlide(heroCurrent + 1);
          resetHeroAuto();
        });
      }

      heroDots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          goToHeroSlide(parseInt(this.getAttribute("data-slide"), 10));
          resetHeroAuto();
        });
      });

      let touchStartX = 0;
      heroTrack.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      heroTrack.addEventListener(
        "touchend",
        (e) => {
          const touchEndX = e.changedTouches[0].screenX;
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) goToHeroSlide(heroCurrent + 1);
            else goToHeroSlide(heroCurrent - 1);
            resetHeroAuto();
          }
        },
        { passive: true }
      );

      if (heroEl) {
        heroEl.addEventListener("mouseenter", function () {
          clearInterval(heroAutoTimer);
        });
        heroEl.addEventListener("mouseleave", function () {
          startHeroAuto();
        });
      }

      startHeroAuto();
    }

    syncHeroVideos();
  }

  // --- Product carousel (same markup as PDP "You might also like"; multiple per page) ---
  function initPdpRecCarousel(pdpRoot) {
    const pdpViewport = pdpRoot.querySelector('[data-js="pdp-rec-viewport"]');
    const pdpTrack = pdpRoot.querySelector('[data-js="pdp-rec-track"]');
    const pdpSlides = pdpRoot.querySelectorAll("[data-pdp-rec-slide]");
    const pdpPrev = pdpRoot.querySelector('[data-js="pdp-rec-prev"]');
    const pdpNext = pdpRoot.querySelector('[data-js="pdp-rec-next"]');
    const pdpDots = pdpRoot.querySelector('[data-js="pdp-rec-dots"]');

    if (!pdpViewport || !pdpTrack || !pdpSlides.length || !pdpDots) return;

    const pdpMq = window.matchMedia("(min-width: 768px)");
    let pdpCurrent = 0;
    let pdpMaxIndex = 0;

    function pdpParseGapPx() {
      const g = getComputedStyle(pdpTrack).gap;
      if (!g || g === "normal") return 0;
      const first = g.split(/\s+/)[0];
      const m = /^([\d.]+)px$/.exec(first);
      return m ? parseFloat(m[1], 10) : 0;
    }

    function pdpUpdateDotsVisual() {
      pdpDots.querySelectorAll(".pdp-rec__dot").forEach((d, i) => {
        if (i === pdpCurrent) d.setAttribute("aria-current", "true");
        else d.removeAttribute("aria-current");
      });
    }

    function pdpRebuildDots() {
      pdpDots.innerHTML = "";
      for (let i = 0; i <= pdpMaxIndex; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "pdp-rec__dot";
        b.setAttribute("aria-label", "Show product " + (i + 1) + " of " + (pdpMaxIndex + 1));
        b.setAttribute("data-pdp-rec-dot", String(i));
        pdpDots.appendChild(b);
      }
      pdpUpdateDotsVisual();
    }

    function pdpLayout() {
      const perView = pdpMq.matches ? 3 : 1;
      const vW = pdpViewport.getBoundingClientRect().width;
      const gapPx = pdpParseGapPx();
      pdpMaxIndex = Math.max(0, pdpSlides.length - perView);
      pdpCurrent = Math.min(pdpCurrent, pdpMaxIndex);

      let slideW = perView > 0 ? (vW - (perView - 1) * gapPx) / perView : vW;
      if (slideW < 0) slideW = 0;

      pdpSlides.forEach((el) => {
        el.style.flexBasis = slideW + "px";
        el.style.width = slideW + "px";
      });

      const step = slideW + gapPx;
      pdpTrack.style.transform = "translateX(-" + pdpCurrent * step + "px)";

      const needDots = pdpMaxIndex > 0 ? pdpMaxIndex + 1 : 0;
      const prevDotsCount = pdpDots.children.length;
      if (needDots === 0) {
        if (prevDotsCount) pdpDots.innerHTML = "";
      } else if (needDots !== prevDotsCount) {
        pdpRebuildDots();
      } else {
        pdpUpdateDotsVisual();
      }

      if (pdpPrev) pdpPrev.disabled = pdpCurrent <= 0 || pdpMaxIndex <= 0;
      if (pdpNext) pdpNext.disabled = pdpCurrent >= pdpMaxIndex || pdpMaxIndex <= 0;
    }

    function pdpGoTo(index) {
      const perView = pdpMq.matches ? 3 : 1;
      const maxI = Math.max(0, pdpSlides.length - perView);
      pdpCurrent = Math.max(0, Math.min(maxI, index));
      pdpLayout();
    }

    pdpDots.addEventListener("click", (e) => {
      const t = e.target.closest(".pdp-rec__dot");
      if (!t || !pdpDots.contains(t)) return;
      const idx = parseInt(t.getAttribute("data-pdp-rec-dot"), 10);
      if (!isNaN(idx)) pdpGoTo(idx);
    });

    if (pdpPrev) pdpPrev.addEventListener("click", () => pdpGoTo(pdpCurrent - 1));
    if (pdpNext) pdpNext.addEventListener("click", () => pdpGoTo(pdpCurrent + 1));

    let pdpTouchStartX = 0;
    pdpTrack.addEventListener(
      "touchstart",
      (e) => {
        pdpTouchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    pdpTrack.addEventListener(
      "touchend",
      (e) => {
        if (pdpMaxIndex <= 0) return;
        const x = e.changedTouches[0].screenX;
        const diff = pdpTouchStartX - x;
        if (Math.abs(diff) > 50) {
          if (diff > 0) pdpGoTo(pdpCurrent + 1);
          else pdpGoTo(pdpCurrent - 1);
        }
      },
      { passive: true }
    );

    pdpMq.addEventListener("change", pdpLayout);
    window.addEventListener("resize", pdpLayout);

    pdpLayout();
  }

  document.querySelectorAll('[data-js="pdp-rec-root"]').forEach(initPdpRecCarousel);
})();
